/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1CovertypesQueryResponse } from '../../types/GetV1Covertypes.ts'

export const getV1CovertypesQueryKey = () => [{ url: '/v1/CoverTypes' }] as const

export type GetV1CovertypesQueryKey = ReturnType<typeof getV1CovertypesQueryKey>

/**
 * {@link /v1/CoverTypes}
 */
export async function getV1Covertypes(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<GetV1CovertypesQueryResponse, ResponseErrorConfig<Error>, unknown>({
        method: 'GET',
        url: `/v1/CoverTypes`,
        ...requestConfig,
    })
    return res
}

export function getV1CovertypesQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1CovertypesQueryKey()
    return queryOptions<
        ResponseConfig<GetV1CovertypesQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1CovertypesQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Covertypes(config)
        },
    })
}

/**
 * {@link /v1/CoverTypes}
 */
export function useGetV1Covertypes<
    TData = ResponseConfig<GetV1CovertypesQueryResponse>,
    TQueryData = ResponseConfig<GetV1CovertypesQueryResponse>,
    TQueryKey extends QueryKey = GetV1CovertypesQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1CovertypesQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1CovertypesQueryKey()

    const query = useQuery(
        {
            ...getV1CovertypesQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
